import React from 'react';
import PropTypes from 'prop-types';
import CostSharingComparison from './CostSharingComparison/CostSharingComparison';
import Deductibles from './Deductibles/Deductibles';

function PlanDrugCosts({ commercialPlanInfo }) {
  return (
    <div
      className="tab-pane fade"
      id="pills-drug-costs-commercial"
      role="tabpanel"
      aria-labelledby="pills-drug-costs-tab"
      tabIndex={0}
    >
      <div>
        <h1 className="drug-name mb-2">Plan &amp; Drug Costs</h1>
        <div className="accordion ps-accordion" id="accordionExample">
          <CostSharingComparison
            costSharing={commercialPlanInfo?.cost_sharing}
          />
          <Deductibles
            data={commercialPlanInfo?.deductibles_and_maximum_out_of_pocket}
          />
        </div>
      </div>
    </div>
  );
}

PlanDrugCosts.propTypes = {
  commercialPlanInfo: PropTypes.object.isRequired,
  commercialDrugInfo: PropTypes.object.isRequired,
};

export default PlanDrugCosts;
